import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';

const DesignationMaster = () => {
    const [designationList, setDesignationList] = useState([]);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [showAddForm, setShowAddForm] = useState(false);
    const [loading, setLoading] = useState(true);
    const [hasBackendError, setHasBackendError] = useState(false);

    const [newDesignation, setNewDesignation] = useState({
        desigCode: '', desigNameEn: '', desigNameII: '', desigShortname: ''
    });

    const [editingCode, setEditingCode] = useState(null);
    const [editValues, setEditValues] = useState({});

    const fetchDesignations = async () => {
        setLoading(true);
        setHasBackendError(false);
        setErrorMessage('');

        try {
            const response = await axios.get(`${process.env.REACT_APP_URL}/api/designation-master/alldesignations`, {
                withCredentials: true
            });

            setDesignationList(response.data.designationList || []);
            setErrorMessage('');
            setHasBackendError(false);
        } catch (err) {
            console.error(err);
            setDesignationList([]);
            setErrorMessage('Internal Exception');
            setHasBackendError(true);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDesignations();
    }, []);

    useEffect(() => {
        if (successMessage || errorMessage) {
            const timer = setTimeout(() => {
                setSuccessMessage('');
                setErrorMessage('');
            }, 8000);
            return () => clearTimeout(timer);
        }
    }, [successMessage, errorMessage]);

    const enableEditing = (desigCode, currentData) => {
        setEditingCode(desigCode);
        setEditValues({
            desigNameEn: currentData.desig_name_en || '',
            desigNameII: currentData.desig_name_ll || '',
            desigShortname: currentData.desig_short_name || '',
            status: currentData.status || 'A'
        });
    };

    const handleEditChange = (field, value) => {
        setEditValues(prev => ({ ...prev, [field]: value }));
    };

    const updateDesignation = async (desigCode) => {
        try {
            const payload = {
                desigCode,
                desigNameEn: editValues.desigNameEn,
                desigNameII: editValues.desigNameII,
                desigShortname: editValues.desigShortname
            };

            const response = await axios.post(`${process.env.REACT_APP_URL}/api/designation-master/update`, payload, {
                withCredentials: true
            });

            if (response.data.status === 'success') {
                setSuccessMessage(response.data.message);
                setEditingCode(null);
                fetchDesignations();
            } else {
                setErrorMessage(response.data.message || 'Failed to update designation.');
            }
        } catch (err) {
            setErrorMessage('Internal Exception');
        }
    };

    const addNewDesignation = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${process.env.REACT_APP_URL}/api/designation-master/add`, newDesignation, {
                withCredentials: true
            });

            if (response.data.status === 'success') {
                setSuccessMessage(response.data.message);
                setShowAddForm(false);
                setNewDesignation({ desigCode: '', desigNameEn: '', desigNameII: '', desigShortname: '' });
                fetchDesignations();
            } else {
                setErrorMessage(response.data.message || 'Failed to add designation.');
            }
        } catch (err) {
            setErrorMessage('Internal Exception');
        }
    };

    return (
        <div id="wrapper">
            <div className="wrapper row3">
                <div id="container">
                    {successMessage && (
                        <p style={{ color: 'green', textAlign: 'center', fontWeight: 'bold' }}>
                            {successMessage}
                        </p>
                    )}

                    {errorMessage && (
                        <p style={{
                            color: '#8B4513',
                            textAlign: 'center',
                            fontWeight: 'bold',
                            textDecoration: 'underline',
                            fontSize: '18px'
                        }}>
                            {errorMessage}
                        </p>
                    )}

                    {loading ? (
                        <div align="center" style={{ marginTop: "40px" }}>
                            <CircularProgress />
                        </div>
                    ) : (
                        <>
                            {!hasBackendError && designationList.length > 0 && (
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <table width="90%" style={{ borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr className="tableheader">
                                                <th colSpan="7">Designation Master</th>
                                            </tr>
                                            <tr className="tableheader">
                                                <th>Sl No.</th>
                                                <th>Designation Code</th>
                                                <th>Designation Name(English)</th>
                                                <th>Designation Name (Local)</th>
                                                <th>Designation Short Name</th>
                                                <th>Status</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {designationList.map((d, index) => {
                                                const isEditing = editingCode === d.desig_code;
                                                return (
                                                    <tr key={d.desig_code}>
                                                        <td>{index + 1}</td>
                                                        <td>{d.desig_code}</td>
                                                        <td>
                                                            {isEditing ? (
                                                                <input
                                                                    value={editValues.desigNameEn}
                                                                    onChange={e => handleEditChange('desigNameEn', e.target.value)}
                                                                />
                                                            ) : d.desig_name_en}
                                                        </td>
                                                        <td>
                                                            {isEditing ? (
                                                                <input
                                                                    value={editValues.desigNameII}
                                                                    onChange={e => handleEditChange('desigNameII', e.target.value)}
                                                                />
                                                            ) : d.desig_name_ll}
                                                        </td>
                                                        <td>
                                                            {isEditing ? (
                                                                <input
                                                                    value={editValues.desigShortname}
                                                                    onChange={e => handleEditChange('desigShortname', e.target.value)}
                                                                />
                                                            ) : d.desig_short_name}
                                                        </td>
                                                        <td>
                                                            {isEditing ? (
                                                                <input
                                                                    value={editValues.status}
                                                                    onChange={e => handleEditChange('status', e.target.value)}
                                                                />
                                                            ) : d.status}
                                                        </td>
                                                        <td style={{ padding: '8px', textAlign: 'center' }}>
                                                            {!isEditing ? (
                                                                <button
                                                                    onClick={() => enableEditing(d.desig_code, d)}
                                                                    className="button button2"
                                                                >
                                                                    Edit
                                                                </button>
                                                            ) : (
                                                                <button
                                                                    onClick={() => updateDesignation(d.desig_code)}
                                                                    className="button button2"
                                                                >
                                                                    Update
                                                                </button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            )}

                            {!hasBackendError && !loading && designationList.length === 0 && (
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    minHeight: '300px'
                                }}>
                                    <p style={{
                                        color: '#8B4513',
                                        fontWeight: 'bold',
                                        textDecoration: 'underline',
                                        fontSize: '18px',
                                        textAlign: 'center'
                                    }}>
                                        No Data Found
                                    </p>
                                </div>
                            )}

                            {!hasBackendError && !loading && designationList.length > 0 && (
                                <>
                                    <hr />
                                    {!showAddForm && (
                                        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '180px' }}>
                                            <button
                                                onClick={() => setShowAddForm(true)}
                                                className="button button2"
                                            >
                                                Add New Designation
                                            </button>
                                        </div>
                                    )}

                                    {showAddForm && (
                                        <div style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', marginBottom: '200px' }}>
                                            <div style={{ width: '30%' }}>
                                                <h3>Add Designation</h3>
                                                <form onSubmit={addNewDesignation}>
                                                    <table width="80%" align="center" cellPadding="5">
                                                        <tbody>
                                                            <tr><td>Code:</td>
                                                                <td><input required value={newDesignation.desigCode}
                                                                    onChange={e => setNewDesignation({ ...newDesignation, desigCode: e.target.value })} />
                                                                </td>
                                                            </tr>
                                                            <tr><td>Name (English):</td>
                                                                <td><input required value={newDesignation.desigNameEn}
                                                                    onChange={e => setNewDesignation({ ...newDesignation, desigNameEn: e.target.value })} />
                                                                </td>
                                                            </tr>
                                                            <tr><td>Name (Local):</td>
                                                                <td><input required value={newDesignation.desigNameII}
                                                                    onChange={e => setNewDesignation({ ...newDesignation, desigNameII: e.target.value })} />
                                                                </td>
                                                            </tr>
                                                            <tr><td>Short name:</td>
                                                                <td><input required value={newDesignation.desigShortname}
                                                                    onChange={e => setNewDesignation({ ...newDesignation, desigShortname: e.target.value })} />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan="2" align="center">
                                                                    <button type="submit" className="button button2" style={{ marginRight: '10px' }}>
                                                                        Add
                                                                    </button>
                                                                    <button type="button" onClick={() => setShowAddForm(false)}
                                                                        className="button button2">
                                                                        Back
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </form>
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}
                        </>
                    )}

                    <button
                        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                        style={{
                            position: 'fixed',
                            right: '18px',
                            bottom: '18px',
                            zIndex: 9999,
                            backgroundColor: '#f1872bff',
                            color: '#100d0dff',
                            border: 'none',
                            padding: '12px 14px',
                            borderRadius: '20px',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                            cursor: 'pointer',
                            fontWeight: 'bold'
                        }}
                        title="Go to Top"
                    >
                        Top
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DesignationMaster;